import React, { useState } from "react";
import VideoGallery from "./VideoGallery";

const media = [
{ url: "https://kodimoottildevi.org/images/gallery/pic-1.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-2.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-3.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-4.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-5.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-6.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-7.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-8.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-9.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-10.jpeg", type: "image"},
{ url: "https://kodimoottildevi.org/images/gallery/pic-11.png", type: "image" },

{ url: "https://kodimoottildevi.org/images/gallery/pic-12.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-13.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-14.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-15.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-16.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-17.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-18.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-19.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-20.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-21.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-22.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/pic-23.jpeg", type: "image" },

{ url: "https://kodimoottildevi.org/images/gallery/img-1.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-2.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-3.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-4.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-5.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-6.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-7.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-8.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-9.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-10.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-11.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-12.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-13.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-14.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-15.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-16.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-17.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-18.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-19.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-20.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-21.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-22.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-23.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-24.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-25.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-26.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-27.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-28.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-29.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-30.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-31.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-32.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-33.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-34.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-35.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-36.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-37.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-38.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-39.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-40.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-41.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-42.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-43.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-44.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/img-45.jpeg", type: "image" },

{ url: "https://kodimoottildevi.org/images/gallery/p-1.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-2.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-3.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-4.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-5.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-6.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-7.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-8.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-9.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-10.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-11.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-12.jpeg", type: "image" },
{ url: "https://kodimoottildevi.org/images/gallery/p-13.jpeg", type: "image" },

  // { url: "https://makreritemple.in/images/video-1.mp4", type: "video" },

];

function PhotoGallery() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openModal = (index) => setSelectedIndex(index);
  const closeModal = () => setSelectedIndex(null);

  const prevItem = () =>
    setSelectedIndex((prev) => (prev === 0 ? media.length - 1 : prev - 1));

  const nextItem = () =>
    setSelectedIndex((prev) => (prev === media.length - 1 ? 0 : prev + 1));

  return (
    <div>

     <div className="row banner" style={{ backgroundImage: 'url(./images/slider-1.png)', backgroundSize: 'cover', backgroundPosition: 'center',backgroundSize:'cover' }}></div>
      <div className="container" style={{ marginTop: '50px', marginBottom: "50px" }}>
        <div style={galleryStyle}>
          {media.map((item, index) => (
            <div key={index} style={itemStyle} onClick={() => openModal(index)}>
              {item.type === "image" ? (
                <img src={item.url} alt="" style={imgStyle} />
              ) : (
                <video src={item.url} style={videoStyle} muted />
              )}
            </div>
          ))}
        </div>
        <VideoGallery />
      </div>

      {selectedIndex !== null && (
        <div style={modalOverlay} onClick={closeModal}>
          <div style={modalContent} onClick={(e) => e.stopPropagation()}>
            <span style={closeBtn} onClick={closeModal}>×</span>

            <button style={navBtnLeft} onClick={prevItem}>❮</button>

            {media[selectedIndex].type === "image" ? (
              <img src={media[selectedIndex].url} style={modalMedia} />
            ) : (
              <video src={media[selectedIndex].url} controls autoPlay style={modalMedia} />
            )}

            <button style={navBtnRight} onClick={nextItem}>❯</button>
          </div>
        </div>
      )}

      
    </div>
  );
}



/* ✅ STYLES (DEFINED ONLY ONCE) */

const galleryStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  gap: "15px",
};

const itemStyle = {
  height: "220px",
  borderRadius: "8px",
  overflow: "hidden",
  cursor: "pointer",
};

const imgStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

const videoStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

/* MODAL */

const modalOverlay = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.9)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalContent = {
  position: "relative",
  maxWidth: "90%",
  maxHeight: "90%",
};

const modalMedia = {
  maxWidth: "100%",
  maxHeight: "90vh",
};

const closeBtn = {
  position: "absolute",
  top: "-40px",
  right: "0",
  fontSize: "30px",
  color: "#fff",
  cursor: "pointer",
};

const navBtnLeft = {
  position: "absolute",
  left: "-50px",
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: "30px",
  background: "none",
  border: "none",
  color: "#fff",
  cursor: "pointer",
};

const navBtnRight = {
  ...navBtnLeft,
  left: "auto",
  right: "-50px",
};

export default PhotoGallery;

